import { render, staticRenderFns } from "./ServicesContent.vue?vue&type=template&id=be914974&"
import script from "./ServicesContent.vue?vue&type=script&lang=js&"
export * from "./ServicesContent.vue?vue&type=script&lang=js&"
import style0 from "./ServicesContent.vue?vue&type=style&index=0&id=be914974&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports